<template>
  <div class="header">
      <div class="left" :style="{'background-image': `url(${header.ambientImg})`}">
        <p ref="headerTitle" class="header-title" :class="{'mini': miniTitle }">{{ header.title }}</p>
        <span class="left_desc">{{ruleMap[rankType] && ruleMap[rankType].content}}</span>
        <!-- 榜单 品类-->
        <slot/>
        <!-- 榜单 -->
      </div>
    </div>
</template>
<script>
export default {
  name: 'multiHeader',
  props: {
    header: {
      type: Object
    },
    ruleMap: {
      type: Object
    },
    rankType:{
      type: [String, Number]
    }
  },
  data() {
    return {
      miniTitle: false,
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.$nextTick(() => {
        let dom = this.$refs.headerTitle;
        let scrH = dom.scrollHeight;
        let offsetH = dom.offsetHeight;
        if (scrH > offsetH) {
          this.miniTitle = true
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.header {
  position: absolute;
  top: 0;
  left: 0;
  .right_bg {
    width: 100%;
  }
  .left {
    position: absolute;
    top: 0;
    left: 0;
    padding-top: 188px;;
    display: flex;
    flex-direction: column;
    background-repeat: no-repeat;
    background-size: 100%;
    background-color: #E8E8E7;
    background-position: top -50px center;
    .header-title {
      margin-left: 48px;
      max-width: 442px;;
      line-height: 66px;
      font-size: 60px;
      font-family: DiDiSans-Pro-Bold;
      color: #8A5321;
      font-weight: 700;
      word-break: break-all;
      word-wrap: break-word;
      overflow: hidden; /*超出隐藏*/
      text-overflow: ellipsis;/*隐藏后添加省略号*/
      -webkit-box-orient:vertical; 
      display: -webkit-box;
      -webkit-line-clamp:2; //想显示多少行
      &.mini {
        font-size: 56px;
      }
    }
    .left_desc {
      margin-top: 20px;
      margin-left: 48px;
      width: 480px;
      opacity: 0.8;
      font-family: DiDiSans-Pro-Medium;
      font-size: 24px;
      color: #975425;
      letter-spacing: 0;
      line-height: 30px;
      font-weight: 400;
    }
  }
}
</style>